import { render, staticRenderFns } from "./ProductionAssetTypes.vue?vue&type=template&id=55be135e&scoped=true&"
import script from "./ProductionAssetTypes.vue?vue&type=script&lang=js&"
export * from "./ProductionAssetTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be135e",
  null
  
)

export default component.exports